import { useMemo } from 'react'

import { executeCode, getValuesFromVariables } from '@helpers'
import { FormDataEnriched, FormLine, FormRow, GETAllVariables, GETVariableDTO, Row } from '@types'

export const useConditionsDisabledMap = ({
  lines,
  row,
  formValues,
  currentRowValues,
  formVariables,
  outerVariables,
}: {
  lines: FormLine<FormDataEnriched>[]
  row: Row | undefined
  formValues: Record<string, unknown>
  currentRowValues?: Record<string, unknown>
  formVariables: GETVariableDTO[]
  outerVariables: GETAllVariables | undefined
}) => {
  return useMemo(() => {
    const map: Record<string, boolean> = {}

    lines.forEach(line => {
      line.elements.forEach(element => {
        const field = element.data as FormRow

        if (field?.conditionsDisabled) {
          map[field.code] = Boolean(
            executeCode(field.conditionsDisabled, {
              srcObj: row ?? {},
              rowData: row ?? {},
              formValues,
              currentRowValues: currentRowValues ?? {},
              formVariables,
              outerVariables: getValuesFromVariables(outerVariables),
              enrichedObject: row ?? {},
            })
          )
        }
      })
    })

    return map
  }, [lines, row, formValues, currentRowValues, formVariables, outerVariables])
}
